import React from 'react';

/** `/account` — reserved for future content; sub-routes render their own views. */
export default function AccountIndex() {
	return null;
}
